export default {
    createTicketCategory: {
        method:"POST",
        url:"/manage-system/counter/category",
        name:"增加商品收银台分类"
    },
    updateTicketCategory: {
        method:"PUT",
        url:"/manage-system/counter/category",
        name:"更改商品收银台分类名称"
    },
    deleteTicketCategory: {
        method:"DELETE",
        url:"/manage-system/counter/category/{id}",
        name:"删除商品收银台分类"
    },
    getTicketCategory: {
        method:"POST",
        url:"/manage-system/counter/category/findCounterCategoryList",
        name:"获取门店商品收银台分类"
    },
    sortTicketCategory: {
        method:"PUT",
        url:"/manage-system/counter/category/sort",
        name:"排序商品收银台分类"
    },
    downTicketCategory: {
        method:"PUT",
        url:"/manage-system/counter/category/down/{id}",
        name:"下架商品收银台分类"
    },
    upTicketCategory: {
        method:"PUT",
        url:"/manage-system/counter/category/up/{id}",
        name:"上架商品收银台分类"
    },
    addTicketInCategory: {
        method:"POST",
        url:"/manage-system/counter/category/ticket",
        name:"新增分类中的票券"
    },
    removeTicketInCategory: {
        method:"DELETE",
        url:"/manage-system/counter/category/ticket",
        name:"删除分类中的票券"
    },
    sortTicketInCategory: {
        method:"PUT",
        url:"/manage-system/counter/category/ticket/sort",
        name:"排序分类中的票券"
    },
    getTicketInCategory: {
        method:"GET",
        url:"/manage-system/counter/category/ticket/{counterCategoryId}",
        name:"获取分类中的票券"
    },
    findAllCategoryGroup: {
        method:"POST",
        url:"/manage-system/counter/category/findAllCategoryGroup",
        name:"获取所有商品分类分组"
    },
    
    thirdGoodsNameMappingList: {
        method:"POST",
        url:"/manage-system/sys/third-order/thirdGoodsNameMapping/page",
        name:"商品名称映射分页查询"
    },
    findAllCategoryGroupAdd: {
        method:"POST",
        url:"/manage-system/sys/third-order/thirdGoodsNameMapping/add",
        name:"商品名称映射新增"
    },
    findAllCategoryGroupEdit: {
        method:"POST",
        url:"/manage-system/sys/third-order/thirdGoodsNameMapping/update",
        name:"商品名称映射编辑"
    },
    findAllCategoryGroupDelete: {
        method:"POST",
        url:"/manage-system/sys/third-order/thirdGoodsNameMapping/delete",
        name:"商品名称映射删除"
    },
    findAllCategoryGroupQuery: {
        method:"POST",
        url:"/manage-system/sys/third-order/thirdGoodsNameMapping/thirdGoodsNameMapping/skuQuery",
        name:"sku查询"
    },
    skuQuery: {
        method:"POST",
        url:"/manage-system/sys/third-order/third-product/mapping/skuQuery",
        name:"sku查询"
    },
    mappingList: {
        method:"POST",
        url:"/manage-system/sys/third-order/third-product/mapping/page",
        name:"三方团购映射分页查询"
    },
    mappingAdd: {
        method:"POST",
        url:"/manage-system/sys/third-order/third-product/mapping",
        name:"三方团购映射新增"
    },
    mappingEdit: {
        method:"PUT",
        url:"/manage-system/sys/third-order/third-product/mapping",
        name:"三方团购映射编辑"
    },
    mappingDelete: {
        method:"DELETE",
        url:"/manage-system/sys/third-order/third-product/mapping/{id}",
        name:"三方团购映射删除"
    },
}
